import Vue from 'vue';
import Router from 'vue-router';
import { decodeQuery, encodeQuery } from 'beans-admin-plugin';

Vue.use(Router);

function getFrontendRoutes(routes = []) {
  return routes.map(route => {
    return {
      ...route,
      path: route.path.startsWith('/') ? route.path.slice(1) : route.path,
      name: `frontend.${route.name}`,
    }
  })
}

export const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: require('@/views/login').default
  },
  // {
  // path: '/register',
  // name: 'register',
  // component: require('@/views/register').default
  // },
  {
    path: '/password',
    name: 'password',
    component: require('@/views/password').default
  },
  {
    path: '/frontend',
    component: require('@/layouts/frontend').default,
    children: [
      ...getFrontendRoutes(require('@/views/reports/customer_structures/ranked_users').route),
      ...getFrontendRoutes(require('@/views/reports/customer_structures/key_behaviors').route),
      ...getFrontendRoutes(require('@/views/reports/customer_structures/index').route),
    ],
  },
  {
    path: '',
    component: require('@/layouts/nav').default,
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          can: []
        },
        component: require('@/views/home').default
      },
      {
        path: '/bind_exists_mini_program',
        name: 'bind_exists_mini_program',
        meta: {
          can: []
        },
        component: require('@/views/bind_wechat/exists_mini_program').default,
      },
      {
        path: '/apply_new_mini_program',
        name: 'apply_new_mini_program',
        meta: {
          can: []
        },
        component: require('@/views/bind_wechat/new_mini_program').default,
      },
      {
        path: '/bind_exists_mini_program/cautions',
        name: 'bind_exists_mini_program.cautions',
        meta: {
          can: []
        },
        component: require('@/views/bind_wechat/cautions').default,
      },
      {
        path: '/mini_program_register',
        name: 'mini_program_register',
        meta: {
          can: 'applications.create'
        },
        component: require('@/views/bind_wechat/register').default,
      },
      {
        path: '/403',
        name: '403',
        component: require('@/views/403').default
      },
      // 以下代码为generator插入代码的标记，请勿修改或删除
      // Generator route
      ...require('@/views/bill_send_records').route,
      ...require('@/views/payment_reminders').route,
      ...require('@/views/customer_sources').route,
      ...require('@/views/operation_logs').route,
      ...require('@/views/sale_channels').route,
      ...require('@/views/product_styles').route,
      ...require('@/views/customer_business_models').route,
      ...require('@/views/customer_transactions').route,
      ...require('@/views/customer_tags').route,
      ...require('@/views/follow_key_items').route,
      ...require('@/views/customer_connections').route,
      ...require('@/views/customer_kinds').route,
      ...require('@/views/work_reports/index.vue').route,
      ...require('@/views/payment_accounts').route,
      ...require('@/views/sales_orders/index').route,
      ...require('@/views/adjustments').route,
      ...require('@/views/payments').route,
      ...require('@/views/jushuitan_inventory_outs').route,
      ...require('@/views/tasks').route,
      ...require('@/views/custom_reports').route,
      ...require('@/views/memos').route,
      ...require('@/views/notifications').route,
      ...require('@/views/jushuitan_after_sales').route,
      ...require('@/views/jushuitan_shops').route,
      ...require('@/views/jushuitan_orders').route,
      ...require('@/views/customer_levels').route,
      //...require('@/views/customer_channels').route,
      ...require('@/views/follow_records').route,
      ...require('@/views/customers').route,
      ...require('@/views/customer_pool').route,
      ...require('@/views/customer_pool_dashboard').route,
      ...require('@/views/customer_quarterly_audit').route,
      ...require('@/views/channels').route,
      ...require('@/views/hot_words').route,
      ...require('@/views/applications').route,
      ...require('@/views/users').route,
      //...require('@/views/admin_users_roles').route,
      ...require('@/views/roles').route,
      ...require('@/views/operation_records').route,
      ...require('@/views/active_storage/blobs').route,
      ...require('@/views/profile/index').route,
      ...require('@/views/profile/change_password').route,
      ...require('@/views/data_analyses/user_portrait').route,
      ...require('@/views/data_analyses/visit_page').route,
      ...require('@/views/data_analyses/visit_distribution').route,
      ...require('@/views/data_analyses/retain_info').route,
      ...require('@/views/data_analyses/visit_trend').route,
      ...require('@/views/banners').route,
      ...require('@/views/custom_pages').route,
      ...require('@/views/pages').route,
      ...require('@/views/reports/receivables/index').route,
      ...require('@/views/reports/commission_sources/index').route,
      ...require('@/views/reports/sales_follows/index').route,
      ...require('@/views/performance_goals/index').route,
      ...require('@/views/reports/customer_structures/ranked_users').route,
      ...require('@/views/reports/customer_structures/key_behaviors').route,
      ...require('@/views/reports/customer_structures/index').route,
      ...require('@/views/reports/customer_sales_amounts').route,
      ...require('@/views/sales_performance_target/index.vue').route,
      ...require('@/views/teams/index.vue').route,
      ...require('@/views/leaderboard/index.vue').route,
    ]
  },
  {
    path: '*',
    name: '404',
    component: require('./views/404').default
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  parseQuery(query) {
    return decodeQuery(query);
  },
  stringifyQuery(query) {
    return encodeQuery(query);
  }
});

export default router
